import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SelectItemParams } from '@core/models/ga4/interfaces/select_item_params';
// import { AlliancesService } from '@core/services/alliances.service';
import { Ga4Service } from '@core/services/ga4.service';
import { UrlService } from '@services/url.service';
import { getNested } from 'globals';
import { PricingExpandableComponent } from '../pricing-expandable/pricing-expandable.component';
import { PricingPopoverComponent } from '../pricing-popover/pricing-popover.component';
import { MbAdviceAlign, MbDialog } from '@am/moebius';
import { PaymentMethodModalComponent } from '../../commons/payment-method-modal/payment-method-modal.component';
@Component({
  selector: 'am-hotel-price',
  styleUrls: ['./hotel-price.component.scss'],
  templateUrl: './hotel-price.component.html',
})
export class HotelPriceComponent implements OnInit {
  @ViewChild('princingExpandable', { static: false })
  public breackdownExpandible: PricingExpandableComponent;
  @ViewChild('pricingPopover', { static: false })
  public breakdownPopover: PricingPopoverComponent;
  @Input()
  public isLanding: any;
  @Input()
  public query: any;
  @Input()
  public hotel: any;
  @Input()
  public currencyToCompensation: string;
  @Output()
  private detailRedirect: EventEmitter<void> = new EventEmitter<void>();
  @Input()
  public context: any;
  @Input()
  public paymentMethodText: string;
  @Input()
  public mbAdvicePosition: MbAdviceAlign;
  @Input()
  public isMobile: any;

  public isAlliance: boolean;
  public superclubPrice: number;
  public includedTaxes: boolean;
  public showAmountTotal: boolean;
  public priceByValue: string;
  public commission: number;
  public totalPrice: number;
  public totalPerNight: number;
  public expand = false;
  public hiddenPopoverPricing = false;
  public isArgentinian: boolean;
  public isBooking: boolean;
  public isExpert = false;
  public currencyCode: string;
  public viewPaymentMethodButton = false;
  public totalWithoutIva = 0;

  constructor(
    // private allianceService: AlliancesService,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MbDialog,
    private ga4Service?: Ga4Service,
    private urlService?: UrlService,
  ) {
    document.addEventListener('OnSelectedPointsRewards', () => {
      setTimeout(() => {
        this.changeDetectorRef.detectChanges();
      }, 0);
    });
  }

  public ngOnInit() {
    this.setCommission();
    this.setTaxes();
    this.isArgentinian = this.hotel.country === '1123215';
    this.isBooking = this.hotel.rate.provider === 'BOOKING';
    this.isExpert = this.urlService.isExperts();
    this.setCurrencyCode();
    this.checkValidViewPaymentMethodButton();
  }

  private setCommission() {
    if (!!getNested(this.hotel, 'rate', 'price')) {
      this.commission =
        this.hotel.rate.price.commission.value - this.hotel.rate.price.commission.tax;
    }
  }

  private setTaxes() {
    this.includedTaxes = !(this.query.queryParams.withFullPrice === 'false');
    this.totalWithoutIva = this.hotel.rate.price.total_without_iva;
    if (this.includedTaxes) {
      if (!this.isLanding) {
        this.totalPrice = this.hotel.rate.price.total_with_service_fee;
        this.totalPerNight = this.hotel.rate.price.price_per_night_per_room_with_service_fee;
      } else {
        this.totalPrice = this.hotel.rate.price.show_amount;
        this.totalPerNight = this.hotel.rate.price.show_amount_per_night_per_room;
      }
    } else {
      if (!this.isLanding) {
        this.totalPrice = this.hotel.rate.price.total;
        this.totalPerNight = this.hotel.rate.price.per_night_per_room;
      } else {
        this.totalPerNight = this.hotel.rate.price.show_amount_per_night_per_room;
      }
    }

    this.priceByValue = this.query.queryParams.priceBy === 'NIGHT' ? 'TOTAL' : 'NIGHT';
    // this.isAlliance = this.allianceService.isAlliance();

    this.setSuperClubPrice();
    this.showAmountTotal = this.query.queryParams.withFullPrice
      ? this.query.queryParams.withFullPrice
      : false;
  }
  public setSuperClubPrice() {
    if (!!getNested(this.hotel, 'rate', 'price')) {
      this.superclubPrice = Math.ceil(
        this.query?.queryParams?.priceBy === 'TOTAL'
          ? this.hotel.rate.price.total
          : this.hotel.rate.price.per_night_per_room,
      );
    }
  }

  public redirectToDetail() {
    if (this.ga4Service !== undefined) {
      this.ga4Service.select_item<SelectItemParams>(this.hotel);
    }
    this.detailRedirect.emit();
  }

  public expandBreakdown() {
    if (this.expand) {
      this.breackdownExpandible.hiddenPane();
    } else {
      this.breackdownExpandible.expand();
    }
    this.expand = !this.expand;
  }

  public showPopover() {
    if (this.expand) {
      this.breakdownPopover.hidden();
    } else {
      this.breakdownPopover.showPop();
    }
    this.expand = !this.expand;
  }

  public hiddenPopover() {
    if (this.hiddenPopoverPricing) {
      this.breakdownPopover.hidden();
      this.expand = false;
    }
    this.hiddenPopoverPricing = !this.hiddenPopoverPricing;
  }

  private setCurrencyCode(): void {
    this.currencyCode = this.hotel.rate.price.currency.code.toUpperCase() === 'USD' ? 'USD' : 'ARS';
  }

  private checkValidViewPaymentMethodButton() {
    this.viewPaymentMethodButton =
      this.context.brand === 'almundo' && !this.isExpert && this.currencyCode === 'USD';
  }

  openDialogPaymentMethod() {
    this.dialog.open(PaymentMethodModalComponent, {
      closeOnEscKey: true,
      closeBtn: true,
      size: 'sm',
    });
  }
}
